import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';

export const Title = styled.h1`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2}
    margin: 27px 0 4px;
    color: ${cssVars.fg_gray1_white};

    ${Screen.ipad} {
        margin: 37px 0 6px;
    }
`;

export const ItineraryContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;

    ${Screen.ipad} {
        grid-gap: 36px;
    }

    ${Screen.desktop} {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr;
        margin: 10px 0 0;
    }
`;

export const Description = styled.div`
    ${Text.Full.large.regular};
    margin: 0 0 17px;
    color: ${cssVars.fg_gray1_white};

    ${Screen.ipad} {
        margin: 0 0 21px;
    }
`;
